import CardElementPhotoControl from './CardElementPhotoControl';

export default CardElementPhotoControl;
